import React, { useEffect, useState } from "react";
import BackTab from "../bars/BackTab";
import LocationSvg from "../../pages/profile/icons/location.svg";
import calendarSvg from "../../pages/profile/icons/calender.svg";
import ticketSvg from "../../images/tickets.svg";
import Counter from "./components/Counter";
import { book_events } from "../../actions/events/event";
import { fetchLoggedMobileNo, formatEventDateTime, formatEventDuration, handleOffers, setLoggedMobileNo, validatePhoneNumber } from "../../utils/util";
import { useNavigate } from "react-router-dom";
import Payment from "../payment/Payment";
import PaymentLoader from "../../components/loaders/PaymentLoader";
import { useDispatch } from "react-redux";
import { setEventRedirect } from "../../slices/LayoutSlice";
     
function GetTickets(props) {
    const [count, setCount] = useState(0);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const{eventData, remainingTickets, updateTicketCount} = props
    const appUserId = localStorage.getItem("appUserId");
    const navigate = useNavigate();
    var amount;
    const [paymentObj, setPaymentObj]= useState({})
    const [razorPopup, setRazorPopup]= useState(false)
    const [paymentLoader, setPaymentLoader]  = useState(false);
    const [mobileValidation, setMobileValidation] =  useState(true);
    const fetchedMobileNo = fetchLoggedMobileNo()
    const [mobileNo, setMobileNo] = useState(fetchedMobileNo)
    const reservationId = localStorage.getItem("reservationId");
    const guestId = localStorage.getItem("guestId");
    const dispatch = useDispatch();
    
    const handlePlus = () => {
      console.log(eventData)
      setError("")
      if(count== eventData?.ticketsRemaining){
        setError("Occupancy reached the limit")
      }else{
        setCount(count + 1);
      }
      };
    
      const handleMinus = () => {
        setError("")
        setCount(count - 1);
      };

      const handleSubmit = async ()=>{
        console.log(razorPopup)
        if(!count){
          setError("Please give occupancy")
        }else if(!mobileNo){
          setError("Please give mobile number")
        }
        else{
          try{
            // const res = await payment_(count , eventData?.id, eventData?.hotelId, appUserId)
            
            if(eventData?.offer){
              amount =  handleOffers(eventData?.rate, parseInt(eventData?.offer)) * count;
            }else{
              amount = count ? eventData?.rate* count : eventData?.rate
            }
            const res =  await book_events(count , eventData?.id, eventData?.hotelId, appUserId , amount, reservationId , guestId , mobileNo)
            console.log(res?.data?.data) //bookedFor, eventId, hotelId, appUserId, amount
            if(res?.data?.success){
              // setSuccess(true)
              setLoggedMobileNo(mobileNo)
              setRazorPopup(true)
              setPaymentObj(res?.data)
              // setTimeout(() => {
              //   setSuccess(false);
              //   navigate("../tickets")
              // }, 2000);
            }else{
              setError(res?.data?.message)
            }
        }catch(e){
          setError("Some error occured")
        }
        }
      }

      const handleMobile = (number)=>{
        console.log(validatePhoneNumber(number))
        setMobileNo(number)
        setError("");
        setMobileValidation(validatePhoneNumber(number))
      }

      // const handleSubmit = async ()=>{
      //   if(!count){
      //     setError("Please give occupancy")
      //   }else{
      //     try{
      //       const res = await book_events(count , eventData?.id, eventData?.hotelId, appUserId)
      //       console.log(res?.data)
      //       if(res?.data?.success){
      //         setSuccess(true)
      //         updateTicketCount(remainingTickets-count)
      //         setTimeout(() => {
      //           setSuccess(false);
      //           navigate("../tickets")
      //         }, 2000);
      //       }else{
      //         setError(res?.data?.message)
      //       }
      //   }catch(e){
      //     setError("Some error occured")
      //   }
      //   }
      // }

      // useEffect(()=>{
      //   dispatch(setEventRedirect(''))
      // },[])

  return (
    <div className="pt-4 min-h-screen relative event-data section-wrap app-wrapper">
      <div className=" flex items-center gap-3 mb-3">
        <BackTab back={() => props.backToEvent()} />
        <div className="event-heading">Get tickets</div>
      </div>
      <div className="event-main-head">
      {eventData?.name}
      </div>
      <div className="mt-4 flex gap-3">
        <img className="h-fit mt-1" src={calendarSvg} alt="" />
        <div className="date-starting" style={{fontSize:"14px"}}>{formatEventDateTime(eventData?.from)}<br/>
            <span>({formatEventDuration(eventData?.from,eventData?.to)})</span>
          </div>
      </div>
      <div className="my-4 flex gap-3">
        <img className="h-fit mt-1" src={LocationSvg} alt="" />
        <div className="date-starting" style={{fontSize:"14px"}}>{eventData?.hotelName}</div>
      </div>
      <div className="my-4 flex gap-3">
          <img className="h-fit w-5" src={ticketSvg} alt="" />
          <div className="date-starting" style={{fontSize:"14px"}}>Remaining Tickets: {remainingTickets}</div>
        </div>
      <hr />
      <div className="bg-indigo-900 rounded-lg p-5 justify-between flex items-center event-data mt-5">
         {
                eventData?.offer ?
                <div className="flex item-center gap-3">
                  <div className="line-through" style={{color:"#a69e9e"}}>₹{count ? eventData?.rate* count : eventData?.rate}</div>
                  <div>₹{   
                  count ?  handleOffers(eventData?.rate, parseInt(eventData?.offer))* count :  handleOffers(eventData?.rate, parseInt(eventData?.offer))
                 }</div>
                </div> 
                  : <div><span>₹</span><span>{count ? eventData?.rate* count : eventData?.rate}</span></div> 
              }
        <Counter handlePlus={handlePlus} handleMinus={handleMinus} count={count}/>
      </div>
      <div className="mt-4">
              
              <label className="mt-6 text-left text-[#D0D0D0] text-12px font-normal">
                          Mobile number
                        </label>
                        <input
                          onChange={(e)=>handleMobile(e.target.value)}
                          className="mt-2 reqInput"
                          type="text"
                          value={mobileNo}
                        />
                      {/* {!mobileValidation && mobileNo && <span className="text-red-500 text-sm">Invalid number</span>} */}
              </div>
      <div className="text-red-500 mt-2 text-center">{error}</div>
      {!mobileValidation && <div className="text-red-500 mt-2 text-center">Invalid Mobile</div>}
       <div className="fixed left-0 bottom-0 w-full">
        <div className="h-full  w-full   section-wrap">
        {success &&
        <div className="text-green-500 font-medium mt-10 text-center flex items-center gap-3 justify-center"><span> Successfully booked!</span><span className="text-lg -mt-1">🎉</span></div>
        }
          <div className="max-w-[500px] mx-auto w-full flex items-center justify-between p-5">            
            <button 
            onClick={()=>handleSubmit()}
            
            // onClick={()=>setSuccessPop(true)}
             className="contact-btn w-full" style={{maxWidth:"none", width:"100%"}}>Book now</button>
          </div>
        </div>
      </div>
      {razorPopup ? <Payment mobileNo={mobileNo} updateTicketCount={()=>updateTicketCount(remainingTickets-count)} hotelId={eventData?.hotelId} paymentObj={paymentObj} price={ eventData?.offer ? (count ?  handleOffers(eventData?.rate, parseInt(eventData?.offer))* count :  handleOffers(eventData?.rate, parseInt(eventData?.offer))) : count ? eventData?.rate* count : eventData?.rate}
      loadingOn = {()=>setPaymentLoader(true)} loadingOff = {()=>setPaymentLoader(false)} appUserId={appUserId} 
      /> :null}

      {paymentLoader && <PaymentLoader/>}
    </div>
  );
}

export default GetTickets;
